function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    justify-self: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    background-image: linear-gradient(\n        to top,\n        rgba(0, 0, 0, 1) 0%,\n        rgba(0, 0, 0, 0.3) 50%,\n        rgba(0, 0, 0, 0.15) 65%,\n        rgba(0, 0, 0, 0.075) 75.5%,\n        rgba(0, 0, 0, 0.037) 82.85%,\n        rgba(0, 0, 0, 0.019) 88%,\n        rgba(0, 0, 0, 0) 100%\n    );\n\n    &:after {\n        content: '';\n        position: absolute;\n        top: 100%;\n        left: 0;\n        right: 0;\n        height: ",
        ";\n        background-color: black;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: grid;\n    grid-template-rows: 1fr;\n    justify-items: center;\n    align-self: stretch;\n    background: ",
        ";\n    padding: ",
        ";\n    z-index: 1;\n\n    > * {\n        grid-area: 1/1;\n    }\n\n    @media screen and (min-width: ",
        ") {\n        display: none;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                    @media screen and (min-width: ",
        ") {\n                        padding: ",
        ";\n                    }\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n                    // Only apply dialog styles above small breakpoint\n                    @media screen and (min-width: ",
        ") {\n                        align-items: center;\n                        justify-content: center;\n                        max-width: ",
        ";\n                        padding: ",
        ";\n                    }\n                "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    box-sizing: border-box;\n    padding: ",
        " ",
        ";\n    width: 100%;\n    min-height: 100%;\n\n    ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n            @media screen and (min-width: ",
        ") {\n                width: 100%;\n                max-width: ",
        ";\n            }\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n    overflow: ",
        ";\n    box-sizing: border-box;\n\n    ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    flex: 1;\n    overflow: hidden;\n\n    @media screen and (min-width: ",
        ") {\n        flex-direction: row;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    padding: ",
        " ",
        ";\n\n    @media screen and (min-width: ",
        ") {\n        padding: ",
        " 0 ",
        ";\n        margin: 0 ",
        ";\n        background: ",
        ";\n    }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    background: ",
        ";\n    position: sticky;\n    top: 0;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n\n    @media screen and (min-width: ",
        ") {\n        position: static;\n        top: auto;\n        width: 33.333%;\n        min-width: ",
        ";\n        overflow: auto;\n    }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n            border-top-left-radius: ",
        ";\n            border-top-right-radius: ",
        ";\n        "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n            @media screen and (min-width: ",
        ") {\n                align-items: center;\n                justify-content: center;\n                border-top-left-radius: unset;\n                border-top-right-radius: unset;\n                border-radius: ",
        ";\n            }\n        "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    background: ",
        ";\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n    height: 100%;\n    width: 100%;\n    contain: content;\n    overflow: hidden;\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n            height: 100%;\n        "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n            @media screen and (min-width: ",
        ") {\n                width: auto;\n            }\n        "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n                    align-self: center;\n                    width: 100%;\n\n                    @media screen and (min-width: ",
        ") {\n                        max-width: ",
        ";\n                    }\n                "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n                    width: 100%;\n                    align-self: center;\n                "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    background: transparent;\n    max-height: 100%;\n    position: relative;\n\n    // override reach dialog styles\n    width: 100%;\n    margin: 0;\n    padding: 0;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n                    padding: ",
        " 0 0 0;\n\n                    @media screen and (min-width: ",
        ") {\n                        padding: ",
        " ",
        " 0;\n                    }\n                "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n                    @media screen and (min-width: ",
        ") {\n                        align-items: center;\n                        justify-content: center;\n                        padding: ",
        ";\n                    }\n                "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    background: rgba(0, 0, 0, ",
        ");\n    contain: strict;\n    height: 100%;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    transition: background 50ms ease;\n\n    // Panel styles\n    align-items: stretch;\n    justify-content: flex-end;\n\n    ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UnhandledError } from "@internal/errors";
import { DialogContent, DialogOverlay } from "@reach/dialog";
import classNames from "classnames";
import { rem } from "polished";
import React, { createContext, forwardRef, useContext, useMemo } from "react";
import styled, { css } from "styled-components";
import { Breakpoint } from "../css/breakpoints";
import { Sticky } from "../css/Sticky";
import { Base } from "../palette/base";
import { semanticColor } from "../palette/semantic";
import CloseIcon from "../svg/close.svg";
import { IconButton } from "./IconButton";
import { MiniBackButton } from "./MiniBackButton";
import { MiniCloseButton } from "./MiniCloseButton";
import { AnimatePresence, motion } from "framer-motion";
var Context = /*#__PURE__*/ createContext(null);
var Modal = function(props) {
    var className = props.className, isOpen = props.isOpen, _fillX = props.fillX, fillX = _fillX === void 0 ? false : _fillX, _fillY = props.fillY, fillY = _fillY === void 0 ? false : _fillY, layout = props.layout, children = props.children, _scrollLock = props.scrollLock, scrollLock = _scrollLock === void 0 ? true : _scrollLock, contentClassName = props.contentClassName, _dismissButton = props.dismissButton, dismissButton = _dismissButton === void 0 ? true : _dismissButton, onDismiss = props.onDismiss, rest = _objectWithoutProperties(props, [
        "className",
        "isOpen",
        "fillX",
        "fillY",
        "layout",
        "children",
        "scrollLock",
        "contentClassName",
        "dismissButton",
        "onDismiss"
    ]);
    var context = useMemo(function() {
        return {
            isOpen: isOpen,
            layout: layout,
            fillX: fillX,
            fillY: fillY,
            dismissButton: dismissButton
        };
    }, [
        isOpen,
        layout,
        fillX,
        fillY,
        dismissButton
    ]);
    return /*#__PURE__*/ _jsxs(Backdrop, _objectSpread({
        className: className,
        isOpen: isOpen,
        layout: layout
    }, rest, {
        dangerouslyBypassScrollLock: !scrollLock,
        onDismiss: onDismiss,
        children: [
            /*#__PURE__*/ _jsxs(Content, {
                className: classNames(contentClassName, layout === "transparent" ? "pointer-events-none" : ""),
                layout: layout,
                $fillY: fillY,
                $fillX: fillX,
                "aria-label": props["aria-label"],
                children: [
                    /*#__PURE__*/ _jsxs(Inner, {
                        layout: layout,
                        className: "[&>*]:pointer-events-auto",
                        children: [
                            /*#__PURE__*/ _jsx(Context.Provider, {
                                value: context,
                                children: props.children
                            }),
                            onDismiss && dismissButton && layout === "dialog" ? /*#__PURE__*/ _jsx(IconButton, {
                                className: "absolute top-3 right-3 !hidden sm:!flex",
                                variant: "secondary",
                                shape: "square",
                                onClick: onDismiss,
                                "aria-label": "Dismiss",
                                children: /*#__PURE__*/ _jsx(CloseIcon, {})
                            }) : null
                        ]
                    }),
                    onDismiss && dismissButton ? /*#__PURE__*/ _jsx(MiniCloseButton, {
                        className: "absolute bottom-full right-4 -translate-y-4 sm:!hidden",
                        onClick: onDismiss
                    }) : null
                ]
            }),
            onDismiss && dismissButton && layout !== "dialog" ? /*#__PURE__*/ _jsx(IconButton, {
                className: "absolute top-3 right-3 !hidden sm:!flex",
                variant: "secondary",
                shape: "square",
                onClick: onDismiss,
                "aria-label": "Dismiss",
                children: /*#__PURE__*/ _jsx(CloseIcon, {})
            }) : null
        ]
    }));
};
export { Modal };
var ModalMain = /*#__PURE__*/ forwardRef(function(props, ref) {
    var children = props.children, className = props.className, _scroll = props.scroll, scroll = _scroll === void 0 ? true : _scroll, rest = _objectWithoutProperties(props, [
        "children",
        "className",
        "scroll"
    ]);
    var _$ref = useContext(Context), layout = _$ref.layout, fillX = _$ref.fillX;
    return /*#__PURE__*/ _jsx(ModalMainContainer, _objectSpread({}, rest, {
        ref: ref,
        overflow: scroll ? "auto" : "hidden",
        layout: layout,
        $fillX: fillX,
        children: /*#__PURE__*/ _jsx(ModalMainInner, {
            className: className,
            layout: layout,
            $fillX: fillX,
            children: children
        })
    }));
});
export { ModalMain };
export var ModalBackButtonMobile = styled(MiniBackButton).withConfig({
    componentId: "sc-a3f7640-0"
})(_templateObject());
export var MODAL_ACTIONS_HEIGHT = 80;
export var ModalActions = function(props) {
    var floating = props.floating, children = props.children;
    return /*#__PURE__*/ _jsx(AnimatePresence, {
        initial: false,
        children: !floating || floating === "visible" ? /*#__PURE__*/ _jsx(ModalActionsStyled, {
            className: "flex-center fixed left-0 bottom-0 right-0 z-[1] w-full gap-2 p-4",
            initial: {
                opacity: 0,
                transform: "translateY(100%)"
            },
            animate: {
                opacity: 1,
                transform: "translateY(0%)"
            },
            exit: {
                opacity: 0,
                transform: "translateY(100%)"
            },
            children: children
        }) : null
    });
};
export var ModalActionsStyled = styled(motion.div).withConfig({
    componentId: "sc-a3f7640-1"
})(_templateObject1(), rem(40));
var ModalStickyHeaderMobile = function(props) {
    var _bg = props.bg, bg = _bg === void 0 ? semanticColor("surface-overlay") : _bg, _pv = props.pv, pv = _pv === void 0 ? 16 : _pv, _ph = props.ph, ph = _ph === void 0 ? 0 : _ph, _shadow = props.shadow, shadow = _shadow === void 0 ? {
        height: 16,
        color: bg,
        to: "bottom",
        position: "bottom"
    } : _shadow, rest = _objectWithoutProperties(props, [
        "bg",
        "pv",
        "ph",
        "shadow"
    ]);
    return /*#__PURE__*/ _jsx(Sticky, {
        sticky: "top",
        shadow: shadow,
        children: /*#__PURE__*/ _jsx(ModalStickyHeaderMobileContainer, _objectSpread({}, rest, {
            bg: bg,
            ph: ph,
            pv: pv
        }))
    });
};
export { ModalStickyHeaderMobile };
export var ModalStickyHeaderMobileContainer = styled.div.withConfig({
    componentId: "sc-a3f7640-2"
})(_templateObject2(), function(param) {
    var bg = param.bg;
    return bg;
}, function(param) {
    var _pv = param.pv, pv = _pv === void 0 ? 16 : _pv, _ph = param.ph, ph = _ph === void 0 ? 0 : _ph;
    return "".concat(rem(pv), " ").concat(rem(ph));
}, rem(Breakpoint.Small));
var ModalMainInner = styled.div.withConfig({
    componentId: "sc-a3f7640-3"
})(_templateObject5(), rem(32), rem(16), function(param) {
    var layout = param.layout, fillX = param.$fillX;
    switch(layout){
        case "panel":
            return css(_templateObject3(), rem(Breakpoint.Small), rem(40));
        case "dialog":
            return css(_templateObject4(), rem(Breakpoint.Small), fillX ? "100%" : rem(580), rem(80));
        case "transparent":
            break;
        default:
            throw new UnhandledError(layout);
    }
});
var ModalMainContainer = styled.div.withConfig({
    componentId: "sc-a3f7640-4"
})(_templateObject7(), function(param) {
    var overflow = param.overflow;
    return overflow;
}, function(param) {
    var $fillX = param.$fillX;
    return css(_templateObject6(), rem(Breakpoint.Small), $fillX ? "100%" : rem(580));
});
export var ModalTwoColumnLayout = styled.div.withConfig({
    componentId: "sc-a3f7640-5"
})(_templateObject8(), rem(Breakpoint.Small));
export var ModalSidebarHeader = styled.div.withConfig({
    componentId: "sc-a3f7640-6"
})(_templateObject9(), rem(24), rem(16), rem(Breakpoint.Small), rem(40), rem(24), rem(40), semanticColor("surface-overlay-secondary"));
export var ModalSidebar = styled.div.withConfig({
    componentId: "sc-a3f7640-7"
})(_templateObject10(), semanticColor("surface-overlay-secondary"), rem(Breakpoint.Small), rem(280));
var Inner = styled.div.withConfig({
    componentId: "sc-a3f7640-8"
})(_templateObject13(), Base.Primary100, function(param) {
    var layout = param.layout;
    return layout === "transparent" ? "transparent" : semanticColor("surface-overlay");
}, function(param) {
    var layout = param.layout;
    return layout !== "transparent" && css(_templateObject11(), rem(24), rem(24));
}, function(param) {
    var layout = param.layout;
    return layout === "dialog" && css(_templateObject12(), rem(Breakpoint.Small), rem(24));
});
var Content = styled(DialogContent).withConfig({
    componentId: "sc-a3f7640-9"
})(_templateObject18(), function(param) {
    var $fillY = param.$fillY;
    return $fillY && css(_templateObject14());
}, function(param) {
    var $fillX = param.$fillX;
    return !$fillX && css(_templateObject15(), rem(Breakpoint.Small));
}, function(param) {
    var layout = param.layout;
    switch(layout){
        case "panel":
            return css(_templateObject16(), rem(Breakpoint.Small), rem(1080));
        case "transparent":
            return css(_templateObject17());
        case "dialog":
            break;
        default:
            throw new UnhandledError(layout);
    }
});
var Backdrop = styled(DialogOverlay).withConfig({
    componentId: "sc-a3f7640-10"
})(_templateObject21(), function(param) {
    var layout = param.layout;
    return layout === "transparent" ? "0.85" : "0.75";
}, function(param) {
    var layout = param.layout;
    switch(layout){
        case "panel":
            return css(_templateObject19(), rem(52), rem(Breakpoint.Small), rem(40), rem(72));
        case "transparent":
        case "dialog":
            return css(_templateObject20(), rem(Breakpoint.Small), rem(72));
        default:
            throw new UnhandledError(layout);
    }
});
